if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

	$('.gallery-slider').slick({
		accessibility: true,
		slidesToShow: 3,
		arrows: true,
		responsive: [{
			breakpoint: 900,
			settings: {
				slidesToShow: 1,
				adaptiveHeight: true
			}
		}]		
	});

    $('.fancybox').fancybox();

     // slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

	// start slider default
    let allSwipper =[];

	document.querySelectorAll('.swiper-js').forEach((element,i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

		element.setAttribute(`data-swiper-${i}`,"");

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

        allSwipper[i] = swiper;

	});

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs option').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs option').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	let selectMenu = document.querySelector('.menu-restaurant__tabs')
	selectMenu && selectMenu.addEventListener('change', (e) => {
		let menuId = selectMenu.value;

		let menu_container = document.querySelectorAll('.menu__unitmenu');
		menu_container = [...menu_container];

		menu_container.forEach( (contendor) => {
			if (contendor.dataset.tag == menuId) {
				contendor.classList.add('active');
			}else{
				contendor.classList.remove('active');
			}
		})

	})

})();